import { notifications } from "@mantine/notifications"
import { useMutation } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useDeleteActivityMutation = () =>
  useMutation({
    mutationFn: async (id: string) => {
      const res = await httpClient.delete(`/admin/activity/${id}`)
      return res.data
    },
    onSuccess: async () => {
      notifications.show({
        title: "Deleted",
        message: "Successfully deleted activity",
        color: "green",
      })
      queryClient.invalidateQueries(["findAllActivities"])
    },
    onError: () => {
      notifications.show({
        title: "Error",
        message: "Failed to delete activity",
        color: "red",
      })
    },
  })
